// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"7b653f30","33":"7c137d5e","243":"0b3953fd","664":"ed96fc7a"}[chunkId] + ".chunk.js";
};